var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpNoBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71111 0.21871C8.50283 0.0104301 8.16514 0.0104301 7.95686 0.21871L0.490194 7.68538C0.281914 7.89366 0.281914 8.23134 0.490194 8.43962C0.698474 8.6479 1.03616 8.6479 1.24444 8.43962L7.80065 1.88341V15.5469C7.80065 15.8317 8.03943 16.0625 8.33398 16.0625C8.62854 16.0625 8.86732 15.8317 8.86732 15.5469V1.88341L15.4235 8.43962C15.6318 8.6479 15.9695 8.6479 16.1778 8.43962C16.3861 8.23134 16.3861 7.89366 16.1778 7.68538L8.71111 0.21871Z",
    fill: "#6429CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpNoBg);
export default __webpack_public_path__ + "static/media/arrow-up-no-bg.a7eb4cd6eedf588788564b0f69de2627.svg";
export { ForwardRef as ReactComponent };